import { createFileRoute, redirect } from "@tanstack/react-router";

/**
 * /creator-kit — DEPRECATED. Consolidated into /creator-studio (Bloque A).
 * Permanent redirect preserves any incoming UTMs / ?ref= params via search passthrough.
 */
export const Route = createFileRoute("/creator-kit")({
  beforeLoad: ({ search }) => {
    throw redirect({ to: "/creator-studio", search: search as Record<string, unknown> });
  },
  component: () => null,
});
